export enum PackTypesEnum {
    PREMIUM_ANNUAL = 'PREMIUM_ANNUAL',
    PREMIUM_MONTHLY = 'PREMIUM_MONTHLY',
    FREE = 'FREE',
    PREMIUM_WITH_GPS_MONTHLY = 'PREMIUM_WITH_GPS_MONTHLY',
    PREMIUM_WITH_GPS_ANNUAL = 'PREMIUM_WITH_GPS_ANNUAL'
}